import Vue from 'vue'
import AMap from './components/amap';
import AMapLocation from './components/amap-location';
import AMapMarker from './components/amap-marker';
// import AMapTrack from './components/amap-track';
import AMapDrawer from './components/amap-drawer';
import AMapShape from './components/amap-shape';
import AMapOverlay from './components/amap-overlay';
import AMapFullscreen from './components/amap-fullscreen';
import AMapStartendMarker from './components/amap-startend-marker';
import AMapHeatmap from './components/amap-heatmap';
import AMapToolbar from './components/amap-toolbar';

const components = [AMap,AMapLocation,AMapDrawer,AMapMarker,AMapShape,AMapOverlay,AMapFullscreen, AMapStartendMarker, AMapHeatmap, AMapToolbar]

let SlAMap = {}

const install = (Vue) => {
  // if (SlAMap.installed) return;
  components.map(com => {
    Vue.component(com.name, com)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

SlAMap.install = install

export default SlAMap